<script>
export default {
  props: ['value'],
  data() {
    return {
      header: this.value.header,
    };
  },
  methods: {
    close() {
      this.$parent.close([null]);
    },
  },
};
</script>

<template lang="pug">
div(:class="$style.root")
  div(:class="$style.closeWrapper")
    ui-icon(:class="$style.close" , @click.native="close",
      tabindex="0",
      @keyup.enter.native="close") close
  header(:class="$style.header")
      div(:class="$style.headerTitle") {{ $t(header) }}
</template>

<style lang="sass" module>
.root
  display: block
  position: relative
  max-width: 700px
.header
  padding: 24px 30px 40px
  &Title
    font-size: 18px
    display: flex
    justify-content: center
.close
  width: 24px
  height: 24px
  color: $color_text_second
  cursor: pointer
  &:hover
    color: $color_text
  &:focus
    outline: none
    color: $color_text
.closeWrapper
  display: flex
  justify-content: flex-end
  padding: 8px 8px 0 0
  width: 100%

</style>
